module.exports = __webpack_public_path__ + "static/media/subhadatta.6bcc4ea6.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/subhadatta.jpg
// module id = 138
// module chunks = 0